import { connect } from 'react-redux'
import * as action from '../../state/cbct-file-upload/action'
import * as customerAction from '../../state/detail/action'
import * as selector from '../../state/cbct-file-upload/selector'
import CbctFileUpload from './CbctFileUpload'
import { FILE_TYPE_CBCT_FILE } from '../../state/const'
import * as customerSelector from '../../state/detail/selector'


const mapStateToProps = state => {
    return {
        ...selector.selectOwnState(state),
        customer: customerSelector.selectCustomer(state),
        fetching: selector.selectIsFetching(state),
        fileType: FILE_TYPE_CBCT_FILE,
        tableSetting: selector.selectTableSetting(state),
    }
}

const mapDispatchToProps = {
    uploadCustomerFile: action.uploadCustomerFile,
    setDeleteFlag: action.setDeleteFlag,
    onUploadSuccess: customerAction.addCustomerFile,
    onFileDeleteFlagSuccess: customerAction.onFileDeleteFlagSuccess,
    changeTableSetting: action.changeTableSetting,
}


export default connect(mapStateToProps, mapDispatchToProps)(CbctFileUpload)



// WEBPACK FOOTER //
// ./src/modules/customer/component/cbct-file-upload/CbctFileUploadContainer.js